import { IconName } from '../src/components/IconName'
import ImageData from './ImageData'

export const singlePropertyControlTypes = ['options-detailed', 'options-circle', 'yes-no'] as const
export const multiPropertyControlTypes = ['multiple-choice'] as const
export type SinglePropertyControlType = typeof singlePropertyControlTypes[number]
export type MultiPropertyControlType = typeof multiPropertyControlTypes[number]
export type PropertyControlType = SinglePropertyControlType | MultiPropertyControlType

export type PropertyDataValue = {
  id: string
  displayName: string
  description?: string
  thumbnail?: ImageData
  value?: number
}

export type PropertyData = {
  id: string
  displayName: string
  isConfigProperty?: boolean
  thumbnail?: ImageData
  description?: string
  values: PropertyDataValue[]
  default?: string | string[]
}

export type FilteredPropertyDataValue = PropertyDataValue & {
  disabled:
    | false
    | {
        reason: string
        type: 'hidden' | 'disabled'
      }
}

export type FilteredPropertyData = Omit<PropertyData, 'values'> & {
  values: FilteredPropertyDataValue[]
}

export type MenuSingleProperty = {
  property: string
  controlType: SinglePropertyControlType
}
export type MenuMultiProperty = {
  controlType: MultiPropertyControlType
  displayName: string
  properties: string[]
}

export type MenuProperty = MenuSingleProperty | MenuMultiProperty
export const isMenuSingleProperty = (p?: MenuProperty): p is MenuSingleProperty => {
  return !!p && (singlePropertyControlTypes as readonly string[]).includes(p.controlType)
}
export const isMenuMultiProperty = (p?: MenuProperty): p is MenuMultiProperty => {
  return !!p && (multiPropertyControlTypes as readonly string[]).includes(p.controlType)
}

export type MenuData = {
  id: string
  displayName: string
  icon: IconName
  contents: MenuProperty[]
}

export type ConstraintData = {
  id: string
  displayName?: string
  description?: string
  comment?: string
  matchAny: { [property: string]: string | string[] }[]
  blacklistValues?: { [property: string]: string[] }
  whitelistValues?: { [property: string]: string[] }
  type?: 'hidden' | 'disabled'
}
